import { toast } from 'react-toastify'

const DIEZ_SEGUNDOS = 10000

export const toastErrorLog = (error, mensaje, tipoError = 'general') => {
  const errorId = error?.response?.data?.errorId
  const mensajeBase = mensaje || 'Ocurrió un error inesperado.'
  const mensajeCompleto = errorId ? `${mensajeBase} (ID: ${errorId})` : mensajeBase

  const TOAST_ERROR_ID = `accion-error-${tipoError}`

  if (toast.isActive(TOAST_ERROR_ID)) {
    toast.update(TOAST_ERROR_ID, {
      render: mensajeCompleto,
      type: 'error'
    })
  } else {
    toast.error(mensajeCompleto, {
      toastId: TOAST_ERROR_ID,
      autoClose: errorId ? false : DIEZ_SEGUNDOS,
      draggable: false,
      closeOnClick: false
    })
  }
}
